import { Table, TableColumnsType } from "antd";
import _ from "lodash";
import moment from "moment";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getAppInstallStatsByDevice } from "../../../api/statistics.api";
import useAxios from "../../../hooks/useAxios";
import config from "../../../lib/config";
import exportTable from "../../../lib/exportTable";
import { IAppInstallStatsByDevice, IGetAppInstallStatsByDevice } from "../../../models/statistics.model";
import { RootState } from "../../../store/rootReducer";
import DownloadButton from "../../DownloadButton";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Pagination from "../../Pagination";

interface IProps {
  res: IGetAppInstallStatsByDevice|undefined;
  pageNo: number;
  setPageNo: (pageNo: number) => void;
  semesterCode: number|undefined;
  campusCode: string|undefined;
}

const Device: FC<IProps> = ({
  res,
  pageNo,
  setPageNo,
  semesterCode,
  campusCode,
}) => {
  const { t } = useTranslation();
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetAppInstallStatsByDevice>();

  useEffect(() => {
    if (res2?.data && !isLoading2) {
      const _data: IAppInstallStatsByDevice[] = _.cloneDeep(res2.data);
      _data.forEach(item => {
        item.installDate = moment(item.installDate).format('YYYY.MM.DD HH:mm');
      });
      const currentDate = moment(new Date());
      exportTable(columns, _data, `${t('statistics.appstudent.title1')}(${t('statistics.appstudent.Tab2')})_(${currentDate.format('YYYYMMDD')})`, `${t('statistics.appstudent.Tab2')}`, [12, 10, 20, 20, 20, 22, 10, 10, 10, 10]);
    }
  }, [res2, isLoading2]);

  const onExportTable = () => {
    if (!semesterCode) return;

    execute2(getAppInstallStatsByDevice({
      semesterCode,
      campusCode: auth.hqYn === 'Y'
        ? campusCode
        : currentCampus,
      pageNo: 1,
      perPage: 999999999,
    }));
  }

  const columns: TableColumnsType<IAppInstallStatsByDevice> = [
    {
      title: t('class.class.placeholder1'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
    },
    {
      title: t('student.student.column5'),
      dataIndex: 'memberKorName',
      key: 'memberKorName',
      align: 'center',
    },
    {
      title: t('auth.login.label1'),
      dataIndex: 'webId',
      key: 'webId',
      align: 'center',
    },
    {
      title: t('student.student.column64'),
      dataIndex: 'memberCode',
      key: 'memberCode',
      align: 'center',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
    },
    {
      title: t('statistics.appstudent.column4'),
      dataIndex: 'osInfo.installDate',
      key: 'osInfo.installDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD HH:mm'),
    },
    {
      title: 'OS',
      dataIndex: 'os',
      key: 'os',
      align: 'center',
    },
    {
      title: t('statistics.appstudent.column5'),
      dataIndex: '',
      key: '',
      align: 'center',
    },
    {
      title: t('statistics.appstudent.column6'),
      dataIndex: 'activeYn',
      key: 'activeYn',
      align: 'center',
    },
    {
      title: t('statistics.appstudent.column7'),
      dataIndex: 'loginYn',
      key: 'loginYn',
      align: 'center',
    },
  ];

  return (
    <>
      {isLoading2 && <Loader />}
      <ErrorResponse error={error2} />

      <div className="comm-bx__between">
        <div className="comm-sch_result">
          Total: {<b>{res?.total}</b>}
        </div>
      </div>
      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={res?.data}
          pagination={{
            current: pageNo,
            pageSize: config.pageSize,
          }}
        />
      </div>
      <div className="comm-bx__between">  
        <DownloadButton onClick={onExportTable} />
        <div className="common-paging center">
          <Pagination
            count={res?.total || 0}
            page={pageNo}
            setPage={setPageNo}
          />
        </div>
      </div>
    </>
  );
}

export default Device;
